 
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Tooltip } from "@mui/material";
import { MdsFormatListNumberedFillXs } from "@sinch/icons";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { MdsIcon } from "../../../MdsIcon/MdsIcon";
import { ToggleToolbarButton } from "../components/ToolbarButton";
import { useOrderedList } from "../hooks/useBlock";

export const OrderedList: FC = () => {
  const { t } = useTranslation();
  const [toggle, isBlock] = useOrderedList();

  const [editor] = useLexicalComposerContext();
  const disabled = !editor.isEditable();
  return (
    <Tooltip placement="top" title={t("TextEditor.bulletedList")}>
      <ToggleToolbarButton disabled={disabled} onClick={toggle} selected={isBlock} tabIndex={-1} value="list">
        <MdsIcon fontSize="xs" icon={MdsFormatListNumberedFillXs} />
      </ToggleToolbarButton>
    </Tooltip>
  );
};
